import { NullLogger } from '@fds/wm-typescript-logger';
import { registerEndpointModule } from '../helpers/store.js';
import 'lodash.set';

const DEFAULT_LOGGER = new NullLogger();
class Mdg2SubscriptionStoreModuleFactory {
  constructor(configuration) {
    var _a;
    this.mdg2Client = configuration.mdg2Client;
    this.options = configuration.options;
    this.logger = (_a = configuration.logger) != null ? _a : DEFAULT_LOGGER;
    if (configuration.store) {
      this.store = configuration.store;
      registerEndpointModule(this.store, this);
    }
  }
  async fetchObservable(payload) {
    return await this.store.dispatch(`${this.getNameSpace()}/fetchObservable`, payload);
  }
  async removeSubscriptionIfInactive(payload) {
    return await this.store.dispatch(`${this.getNameSpace()}/removeSubscriptionIfInactive`, payload);
  }
  async getObservable(payload) {
    return await this.store.dispatch(`${this.getNameSpace()}/getObservable`, payload);
  }
  getData(payload) {
    return this.store.getters[`${this.getNameSpace()}/getData`](payload);
  }
}

export { Mdg2SubscriptionStoreModuleFactory };
